import React from 'react';
import { FiClock, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { Card, CardContent } from '../common/Card';

const EvaluationStatus = ({ status, processingTime }) => {
  let statusContent;

  switch (status) {
    case 'pending':
      statusContent = (
        <div className="flex flex-col items-center gap-2 text-yellow-500">
          <FiClock className="h-12 w-12" />
          <h3 className="text-lg font-medium">评估进行中</h3>
          <p className="text-sm text-muted-foreground text-center">
            正在分析简历和职位描述，请稍候...
          </p>
          <div className="w-full max-w-xs bg-accent rounded-full h-2 mt-2">
            <div className="bg-yellow-500 h-2 rounded-full animate-pulse"></div>
          </div>
        </div>
      );
      break;
    case 'completed':
      statusContent = (
        <div className="flex flex-col items-center gap-2 text-green-500">
          <FiCheckCircle className="h-12 w-12" />
          <h3 className="text-lg font-medium">评估完成</h3>
          <p className="text-sm text-muted-foreground text-center">
            评估已完成，处理时间: {processingTime ? `${processingTime}秒` : '未知'}
          </p>
        </div>
      );
      break;
    case 'failed':
      statusContent = (
        <div className="flex flex-col items-center gap-2 text-destructive">
          <FiAlertCircle className="h-12 w-12" />
          <h3 className="text-lg font-medium">评估失败</h3>
          <p className="text-sm text-muted-foreground text-center">
            评估过程中出现错误，请重试
          </p>
        </div>
      );
      break;
    default:
      statusContent = (
        <div className="flex flex-col items-center gap-2">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-sm text-muted-foreground">加载中...</p>
        </div>
      );
  }

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardContent className="pt-6 flex justify-center">
        {statusContent}
      </CardContent>
    </Card>
  );
};

export default EvaluationStatus;
